
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';


function Msfabricationdoor() {



  const cardData =
  {
    keyword: 'MS Fabrication Door Installation',
    heading: 'Anjali Enterprises: MS Fabrication Door Installation',
    headingDescription: 'Anjali Enterprises specializes in MS (Mild Steel) fabrication door installation, offering robust, durable, and custom-made steel doors for various applications. Our MS doors are ideal for both residential and commercial properties, providing high security, strength, and aesthetic appeal. Whether you need a steel door for your home, office, or industrial space, we offer professional fabrication and installation services that guarantee quality and longevity.',

    "topPlaces": [
        {
          "title": "Mild Steel Door Fabrication",
          "description": "We provide expert mild steel door fabrication services, creating doors that are not only strong but also tailored to meet your specific needs. Our skilled team ensures that every MS door is precisely fabricated to provide superior security and performance."
        },
        {
          "title": "Custom MS Doors",
          "description": "Our custom MS doors are designed to suit the unique requirements of your space. From residential homes to commercial establishments, we offer a wide range of design options that align with your style while ensuring maximum security and durability."
        },
        {
          "title": "Industrial Steel Doors",
          "description": "Anjali Enterprises offers industrial steel doors designed to withstand the rigors of commercial and industrial environments. These doors are built to provide exceptional security, longevity, and resistance to wear and tear."
        },
        {
          "title": "Steel Door Contractors in Pune",
          "description": "As leading steel door contractors in Pune, we are known for our reliable and high-quality MS door fabrication and installation services. Our team ensures timely and efficient service delivery while maintaining high standards of craftsmanship."
        },
        {
          "title": "MS Doors for Homes and Offices",
          "description": "We offer MS doors for both homes and offices, providing stylish and secure door solutions that complement your property’s design. Our MS doors are perfect for creating a modern and secure environment for any space."
        },
        {
          "title": "Fabricated Steel Door Solutions",
          "description": "Our fabricated steel doors are designed to offer maximum security while enhancing the overall aesthetic of your space. These doors are made from high-quality materials and are fabricated with precision to ensure optimal performance and durability."
        },
        {
          "title": "MS Door Design and Installation",
          "description": "At Anjali Enterprises, we offer expert MS door design and installation services. We work closely with clients to understand their needs and provide doors that are both functional and aesthetically pleasing, ensuring a perfect fit for any space."
        },
        {
          "title": "MS Door Services in Pune",
          "description": "We offer comprehensive MS door services in Pune, including custom fabrication, installation, and maintenance. Our skilled team ensures that every door is installed to the highest standards and is built to last."
        },
        {
          "title": "High-Quality Steel Doors for Commercial Use",
          "description": "Our high-quality steel doors for commercial use provide superior strength, security, and durability. These doors are ideal for offices, warehouses, factories, and other commercial buildings where security is a top priority."
        },
        {
          "title": "Anjali Enterprises Contact Number",
          "description": "Contact Anjali Enterprises at +91 8793220265 for reliable and high-quality MS (Mild Steel) fabrication door installation services. We specialize in designing and fabricating durable and strong MS doors for both residential and commercial properties, providing excellent security and aesthetic appeal. Get in touch for expert installation and professional service. Serving Pune with top-notch MS fabrication door solutions tailored to your needs."
        }
      ],
      "tableData": [
        ["- Mild Steel Door Fabrication", "- Custom MS Doors"],
        ["- Industrial Steel Doors", "- Steel Door Contractors in Pune"],
        ["- MS Doors for Homes and Offices", "- Fabricated Steel Door Solutions"],
        ["- MS Door Design and Installation", "- MS Door Services in Pune"],
        ["- High-Quality Steel Doors for Commercial Use", "- Anjali Enterprises Contact Number"],
        ["", ""]
      ],


   "whychoose": [
  {
    "WhyChooseheading": "Durability and Strength",
    "WhyChoosedescription": "At Anjali Enterprises, we specialize in MS (Mild Steel) fabrication doors that are known for their strength, durability, and long-lasting performance. Whether for residential, commercial, or industrial properties, our MS doors offer robust security and protection."
  },
  {
    "WhyChooseheading": "Customizable Designs",
    "WhyChoosedescription": "We understand that every property is unique. Our MS fabrication doors can be customized to suit your specific needs, including different sizes, shapes, and designs. From simple styles to intricate patterns, we ensure that your door fits perfectly with your space and security requirements."
  },
  {
    "WhyChooseheading": "Affordable and High-Quality",
    "WhyChoosedescription": "Our MS fabrication doors are made from premium-grade mild steel, ensuring excellent quality at competitive prices. We combine affordability with durability, providing you with a cost-effective security solution for your home or business."
  },
  {
    "WhyChooseheading": "Versatile Applications",
    "WhyChoosedescription": "MS fabrication doors are versatile and can be installed in various locations such as entrances, gates, garage doors, balconies, and even as partition doors in offices. They offer excellent protection for both residential and commercial properties."
  },
  {
    "WhyChooseheading": "Corrosion-Resistant",
    "WhyChoosedescription": "We ensure that our MS doors are designed to withstand various weather conditions. Our doors are treated with anti-corrosive coatings, making them resistant to rust and ensuring long-term performance, even in humid or rainy environments."
  },
  {
    "WhyChooseheading": "Professional Installation",
    "WhyChoosedescription": "Our experienced team of technicians ensures that your MS doors are fabricated and installed with precision. We use advanced techniques and high-quality materials to deliver a flawless installation, providing maximum security and durability."
  },
  {
    "WhyChooseheading": "Enhanced Security",
    "WhyChoosedescription": "MS doors provide excellent security and can be reinforced with additional features such as locks, hinges, and frames. Whether it's for home or business security, our MS fabrication doors are built to protect your property effectively."
  },
  {
    "WhyChooseheading": "Easy Maintenance",
    "WhyChoosedescription": "MS fabrication doors require minimal maintenance. They are easy to clean and maintain their appearance and functionality for years. We also offer repair and maintenance services for long-term upkeep."
  },
  {
    "WhyChooseheading": "Sleek and Modern Appearance",
    "WhyChoosedescription": "Our MS doors are designed to not only be functional but also stylish. Whether you want a modern look or a traditional aesthetic, we offer a variety of finishes and designs to enhance the look of your property."
  }
]


  }

  const faqData = [
    {
      question: "What is an MS fabrication door?",
      answer: "An MS (Mild Steel) fabrication door is a door made from strong, durable mild steel that is fabricated into various designs. It is used for security purposes and is known for its robustness and resistance to wear and tear."
    },
    {
      question: "Can MS fabrication doors be customized?",
      answer: "Yes, MS fabrication doors can be fully customized according to your requirements. We offer a range of designs, sizes, and finishes to suit your property’s needs."
    },
    {
      question: "Are MS fabrication doors resistant to rust?",
      answer: "Yes, our MS doors are treated with anti-corrosive coatings to prevent rust and corrosion, ensuring long-lasting durability even in humid or rainy conditions."
    },
    {
      question: "Are MS doors suitable for both residential and commercial use?",
      answer: "Absolutely! MS doors are ideal for both residential and commercial properties. They provide robust security and can be installed at entrances, gates, balconies, and more."
    },
    {
      question: "How long will MS fabrication doors last?",
      answer: "MS fabrication doors are highly durable and can last for many years with proper maintenance. They are built to withstand harsh conditions and require minimal upkeep."
    },
    {
      question: "How do I maintain my MS fabrication door?",
      answer: "MS fabrication doors are low-maintenance. Simply clean them regularly with mild detergent and water to keep them looking great. We also provide maintenance services to ensure your doors stay in excellent condition."
    },
    {
      question: "How do I know if an MS fabrication door is right for my property?",
      answer: "Our expert team can assess your property and recommend the best MS door solutions based on your security needs, aesthetics, and budget. We offer a variety of designs to suit different properties."
    },
    {
      question: "How much does MS fabrication door installation cost?",
      answer: "The cost depends on the size, design, and customization options. We offer competitive pricing and free consultations to help you find a solution that fits your budget."
    },
    {
      question: "Can MS fabrication doors be used for gates?",
      answer: "Yes, MS fabrication doors are perfect for use as gates. We offer custom solutions for both residential and commercial gates, ensuring security and a modern look."
    },
    {
      question: "Why should I choose Anjali Enterprises for MS fabrication door installation?",
      answer: "Anjali Enterprises offers high-quality, durable MS fabrication doors with professional installation. We provide customized solutions, affordable pricing, and long-lasting results, ensuring the security and style of your property."
    }
  ];
  
  const testimonials = [
    {
      name: "Mr. Ramesh Joshi",
      text: "We needed an MS fabrication door for our office entrance, and Anjali Enterprises delivered an excellent product. The door is strong, secure, and looks great. Their installation team was efficient and professional. Highly recommended!"
    },
    {
      name: "Mrs. Aarti Sharma",
      text: "Anjali Enterprises installed an MS fabrication door at our home, and we are extremely happy with the result. The door is sturdy, well-designed, and adds a modern touch to our home. The installation was smooth and hassle-free."
    }
  ];
  



  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>{testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: " Anjali Enterprises Contact Information:",
    contactNumbers: [
      "+91 8793220265",

    ],
    email: "info@anjalienterprisesindia.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "All Types of Aluminium Glass Office Partition",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "All Types of Toughened Glass Work",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Door Partition",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "ACP Cladding Panel Installation",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Aluminium Glass Window",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Soundproof Glass Window",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Aluminium Mosquito Net",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bird Net Installation",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Invisible Grill Installation",
    },
    {
      place: "/images/keyword/10.jpg",
      text: " MS Fabrication Door",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "MS Fabrication Shade",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "MS Fabrication Grill",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "MS Fabrication Slide Door ",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "MS Fabrication Industrial Shade",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "All Types of Industrial Fabrication Work",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "All Types of Furniture Work",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "All Types of Industrial Work",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "All Types of Home Renovation Work",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "All Types of Painting Work",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Foil Ceiling Work",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Electrical Work",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Puff Panel Room ",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "PCC Work & Epoxy Flooring Work ",
    },
  ];


  const images = [
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },

  ];



  return (
    <div>


<Helmet>
  <title> Anjali Enterprises | MS Fabrication Door Installation Services in Pune</title>
  <meta name="description" content="Anjali Enterprises offers MS fabrication door installation services in Pune, providing custom mild steel doors, industrial steel doors, and high-quality steel doors for homes and commercial use. Call +91 8793220265 for MS door solutions." />
  <meta name="keywords" content="MS Fabrication Door Installation, Mild Steel Door Fabrication, Custom MS Doors, Industrial Steel Doors, Steel Door Contractors Pune, MS Doors for Homes and Offices, Fabricated Steel Door Solutions, MS Door Design and Installation, MS Door Services in Pune, High-Quality Steel Doors for Commercial Use" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | MS Fabrication Door Installation Services in Pune" />
  <meta property="og:description" content="Anjali Enterprises offers MS fabrication door installation services in Pune, providing custom mild steel doors, industrial steel doors, and high-quality steel doors for homes and commercial use. Call +91 8793220265 for MS door solutions." />
  <meta property="og:image" content="https://anjalienterprisesindia.com/images/ms-fabrication-door-service.jpg" />
  <meta property="og:url" content="https://anjalienterprisesindia.com/ms-fabrication-door-installation" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Anjali Enterprises" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Anjali Enterprises",
        "description": "Anjali Enterprises offers MS fabrication door installation services in Pune, providing custom mild steel doors, industrial steel doors, and high-quality steel doors for homes and commercial use. Call +91 8793220265 for MS door solutions.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8793220265",
        "email": "info@anjalienterprisesindia.com",
        "url": "https://anjalienterprisesindia.com/ms-fabrication-door-installation",
        "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
        "image": "https://anjalienterprisesindia.com/images/ms-fabrication-door-service.jpg",
        "priceRange": "₹4000 - ₹15000",
        "offers": {
          "@type": "Offer",
          "url": "https://anjalienterprisesindia.com/ms-fabrication-door-installation",
          "priceCurrency": "INR",
          "price": "4000",
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "35"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Anil T"
            },
            "datePublished": "2024-05-28",
            "reviewBody": "The MS fabrication doors we installed for our factory were perfect. Strong, durable, and professionally installed. The team was very skilled. Highly recommend!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rina M"
            },
            "datePublished": "2024-08-10",
            "reviewBody": "We had custom MS doors installed at our office, and the work was fantastic. Great quality and prompt service. Will definitely use Anjali Enterprises again!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Anjali Enterprises Service Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://anjalienterprisesindia.com/ms-fabrication-door-installation"
        },
        "keywords": "MS Fabrication Door Installation, Mild Steel Door Fabrication, Custom MS Doors, Industrial Steel Doors, Steel Door Contractors Pune, MS Doors for Homes and Offices, Fabricated Steel Door Solutions, MS Door Design and Installation, MS Door Services in Pune, High-Quality Steel Doors for Commercial Use"
      }
    `}
  </script>
</Helmet>



      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1 className='text-white'>{cardData.keyword}</h1>
        </div>
      </div>



      <section>
        <div className="" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/10.jpg' className='img-fluid' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#24ABE2', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}

              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {/* {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))} */}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <h3 className='Colo'>Why Choose Anjali Enterprises for {cardData.keyword}  </h3>

              <div id="why-choose-section"
                className='px-2'>


                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>

              <div>
                <h3 className='Colo'>FAQs{cardData.keyword} for Anjali Enterprises</h3>
                <Accordion data={faqData} />
              </div>
              <div className=''>


                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>

              <div className='py-5'>

                <div className="contact-box borderrr py-md-3">
                  <h2>{contactData.heading}</h2>
                  <p>For inquiries, quotes, or assistance with your aluminium glass office partition needs, please contact us:</p>
                  <div className="contact-details">
                    <p><strong className=''>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5 darkcolor">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className=''>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link darkcolor">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >

              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>

                );
              })}










              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '1px solid #24ABE2',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                  color: 'white'
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#24ABE2' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8793220265 " className="d-block  text-white">+91 8793220265 </a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@anjalienterprisesindia.com" className=" text-white d-block">
                          info@anjalienterprisesindia.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i>

                            Anjali Enterprises:<br />
                            Shop No 7 Vishal Deep Residency M  <br />
                            Perk Nagar Highway, Chandan Nagar<br />
                            Vadgaon Sheri,  (Near NA Bus Stop) Pune <br />
                            Maharashtra 411014
                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Gallery images={images} ></Gallery>

              </div>

            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Msfabricationdoor;